'use strict';
import '@/_constant/global';
import pageTop from '@/_page/pageTop';

document.addEventListener('DOMContentLoaded', () => {
  gPG.mods['page'] = new pageTop();
}, false);

window.addEventListener('load', () => {
  gPG.mods['page'].start();
}, false);

window.addEventListener('unload', () => {}, false);
